<template>
  <div class="online-cv-wrapper" :style="iosOrAndroidStyle">
    <w-nav-bar @mobileLeftBtn="routerBack" v-show="iosOrAndroidShow"/>
    <div class="online-header">
      <p class="headline title">验证手机号</p>
    </div>
    <div class="phone-number-wrapper">
      <div class="phone-number flex">
        <span class="number">86</span>
        <input v-model="phone" type="text" placeholder="输入手机号">
      </div>
      <div class="verify-code flex">
        <input type="text" v-model="verifyCode" placeholder="输入验证码">
        <span class="verify-btn" :class="{'sending-code': sending}" @click="sendVerifyCode">{{ verifyText }}</span>
      </div>
    </div>
    <div class="online-footer footer">
      <button class="theme-button flex-center footer-button" :class="{'disable-button': disableState}"
              @click="savePhone">保存
      </button>
    </div>
  </div>
</template>

<script>
	import WNavBar from '@/components/global/w-navbar'
	import { mapActions, mapState } from 'vuex'
	import { componentsMixin } from '@/assets/js/mixin/components'
	import { verifyRequired } from '../../assets/js/utils'

	import Cookies from 'js-cookie'
	import { envMixin, eventMixin } from '../../assets/js/mixin/global'


	export default {
		name: 'phone-info',
		mixins: [ componentsMixin, eventMixin, envMixin ],
		data () {
			return {
				sending: false,
				second: 60,
				phone: '',
				verifyCode: ''
			}
		},
		async mounted () {
			await this.iosBridgeGet()
			// this._initPhoneNumber()
		},
		computed: {
			...mapState('cv', ['cv', 'onlineCvBasic']),
			verifyText () {
				return this.sending ? `${ this.second } 秒后重发` : '获取验证码'
			},
      cvAccountToken () {
	      let _t = Cookies.get('_t')
	      let tokenPayload = JSON.parse(window.atob(_t.split('.')[1]))
	      return tokenPayload.User.c_t
      },
			requiredField () {
				return [
					{ val: this.phone, message: '请填写手机号' },
					{ val: this.verifyCode, message: '请填写验证码' }
				]
			},
			disableState () {
				return verifyRequired(this.requiredField)
			}
		},
		watch: {},
		components: {
			WNavBar
		},
		methods: {
			sendVerifyCode () {
				if (!this.sending) {
					if (!/^1[3456789]\d{9}$/.test(this.phone)) {
						this.showToast('请输入正确的手机号')
						return
					}
					this.sending = true
					this._sendCode()
					let timer = setInterval(() => {
						this.second -= 1
						if (this.second === 0) {
							clearInterval(timer)
							this.sending = false
							this.second = 60
						}
					}, 1000)
				}
			},
			async _sendCode () {
				let res = await this.$api.online.getPhoneValidateCode({ phone: this.phone }, this.cvAccountToken)
				if (res.code === 200901) this.showToast('发送成功')
			},
			async savePhone () {
				if (verifyRequired(this.requiredField)) {
					this.showToast(verifyRequired(this.requiredField), 2000)
          return
				}
				let payload = {
					phone: this.phone,
          code: this.verifyCode
        }
				let res = await this.$api.online.verifyPhoneCode(payload, this.cvAccountToken)
        if (res.code === 1000) {
        	this.onlineCvBasic.contact = this.phone
          this.iosBridgeSave()
	        this.routeBack(`/cvs/online/${ this.$route.params.online_token }/base`)
        } else if (res.code === 2009) {
        	this.showToast(res.message)
        }
			},
      _initPhoneNumber () {
				this.phone = this.cv.profile.phone
      },
			routerBack () {
				this.$router.back()
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/mixin';
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/cv/online-cv';
  .phone-number-wrapper {
    padding: 0 24px;
    .phone-number, .verify-code {
      padding: 18px 0;
      border-bottom: 1px solid #EBEBEB;
      align-items: center;
    }
    .phone-number {
      align-items: center;
      margin-top: 14px;
      span {
        color: $color-title;
        &::after {
          content: '|';
          margin: 0 16px;
          color: #D8D8D8;
        }
        &::before {
          display: inline-block;
          content: '+';
          color: $color-title;
          margin-bottom: 2px;
        }
      }
    }
    .verify-btn {
      color: #4183FF;
      font-size: $font-size-medium-x;
    }
    .sending-code {
      color: rgba($color: #4183FF, $alpha: 0.6);
    }
    input {
      flex: 1;
      border: none;
      font-size: $font-size-medium-x;
      padding: 0;
      &::placeholder {
        color: #DBDBDB;
      }
    }
  }
</style>
